import React from 'react';
import { cn } from '../../../lib/utils';
import { Globe, Building2 } from 'lucide-react';

export interface GameLeaderboardScopeTabsProps {
  scope: 'world' | 'node';
  onScopeChange: (scope: 'world' | 'node') => void;
  nodeName?: string;
  className?: string;
}

export function GameLeaderboardScopeTabs({
  scope,
  onScopeChange,
  nodeName = 'Chapter',
  className
}: GameLeaderboardScopeTabsProps) {
  return (
    <div className={cn("grid grid-cols-2 border-2 border-black dark:border-white font-mono text-xs mb-3 shadow-[3px_3px_0px_#000000] dark:shadow-[3px_3px_0px_#FFFFFF]", className)}>
      <button
        type="button"
        onClick={() => onScopeChange('world')}
        className={cn(
          "flex items-center justify-center gap-1.5 py-2 px-3 uppercase tracking-wider font-black transition-colors rounded-none border-r-2 border-black dark:border-white",
          scope === 'world'
            ? "bg-[#FFD600] text-black"
            : "bg-neutral-900 text-neutral-400 hover:text-white hover:bg-neutral-800"
        )}
      >
        <Globe size={13} className="shrink-0" />
        <span className="truncate">World</span>
      </button>

      <button
        type="button"
        onClick={() => onScopeChange('node')}
        className={cn(
          "flex items-center justify-center gap-1.5 py-2 px-3 uppercase tracking-wider font-black transition-colors rounded-none",
          scope === 'node'
            ? "bg-[#0044FF] text-white"
            : "bg-neutral-900 text-neutral-400 hover:text-white hover:bg-neutral-800"
        )}
        title={nodeName}
      >
        <Building2 size={13} className="shrink-0" />
        <span className="truncate">{nodeName}</span>
      </button>
    </div>
  );
}
